/**
 * Convert binary data to string
 *
 * Suitable for decoding lower level parts of encrypted data such as keys,
 * IVs, and encrypted data that has already been processed by
 * `binaryToStringUnicode()`
 *
 * To decode stringified `RawData`, use `stringToBinary()` instead.
 */
const binaryToString = buffer => new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '');
/**
 * Convert string to binary data
 *
 * Suitable for converting lower level parts of encrypted data such as keys,
 * IVs, and encrypted data that has already been processed by
 * `stringToBinaryUnicode()`
 *
 * To encode stringified `RawData`, use `stringToBinaryUnicode()` instead.
 */

const stringToBinary = str => {
  const buffer = new ArrayBuffer(str.length);
  const bufferInterface = new Uint8Array(buffer);
  Array.from(str).forEach((_, index) => {
    bufferInterface[index] = str.charCodeAt(index);
  });
  return buffer;
};
/**
 * Convert binary data to string, supporting UTF-8 multi-byte characters such
 * as ™ and 😊.
 *
 * Suitable for decoding data received from `crypto.subtle.decrypt()`
 *
 * To decode keys, IVs and preprocessed encrypted data, use `binaryToString()`
 * instead.
 */

const binaryToStringUnicode = buffer => new TextDecoder().decode(buffer);
/**
 * Convert string to binary data, supporting UTF-8 multi-byte characters such
 * as ™ and 😊.
 *
 * Suitable for preparing data to be passed to `crypto.subtle.encrypt()`
 *
 * To encode keys and already processed encrypted data, use
 * `stringToBinary()` instead.
 */

const stringToBinaryUnicode = str => new TextEncoder().encode(str);

export { binaryToString, binaryToStringUnicode, stringToBinary, stringToBinaryUnicode };
